export default __webpack_public_path__ + "static/media/AE_card2.a9d2fef2.webp";